import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import SentimentDissatisfiedRoundedIcon from '@mui/icons-material/SentimentDissatisfiedRounded'
import { Box, Stack, Typography, useTheme } from '@mui/material'

import OfuManageBackButton from '~/features/campaigns/components/ofuManageCampaign/ofuManageBackButton'
import rem from '~/utils/ui'

export default function CampaignPageNotFound() {
  const theme = useTheme()

  return (
    <Stack
      sx={{
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        px: rem(24),
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.common.white,
          border: `${rem(1)} solid ${theme.palette.divider}`,
          borderRadius: rem(16),
          maxWidth: rem(560),
          width: '100%',
          py: rem(48),
          px: rem(24),
          textAlign: 'center',
          gap: rem(12),
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
        >
          <Box
            sx={{
              width: rem(48),
              height: rem(48),
              borderRadius: '50%',
              backgroundColor: theme.palette.mainBackground,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SearchOffRoundedIcon
              sx={{ fontSize: rem(28), color: theme.palette.text.secondary }}
            />
          </Box>
          <SentimentDissatisfiedRoundedIcon
            sx={{ fontSize: rem(32), color: theme.palette.text.secondary }}
          />
        </Stack>

        <Typography variant="h5" color={theme.palette.mainFont}>
          We couldn&apos;t find that page
        </Typography>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          The campaign may not exist or you may not have access to it.
        </Typography>
        <Box sx={{ mt: rem(8) }}>
          <OfuManageBackButton />
        </Box>
      </Stack>
    </Stack>
  )
}
